import Controller from '@ember/controller';

export default class AboutController extends Controller {
  declare model: { yearsOfExperience: number };
  
  get yearsOfExperience() {
    return this.model.yearsOfExperience;
  }
}

